import React, { useEffect, useState } from 'react'
import styles from './style/golbal-tem.module.less'
import StepHeaderMod from './StepHeaderMod'
import EmptyMod from './TemEmptyMod'
import TemRightMod from './TemRightMod'
import TemFormMod from './TemFormMod'
import Icon1 from '../../assets/newImgs/h-i3.svg'
import { GetQueryValue } from '@/utils/common'
import { getUserInfo } from '@/model/reference'

function GolbalTem(props) {
  //鉴权登录状态
  useEffect(() => {
    getUserInfo({ uid: '' }).then((res) => {
      console.log(res)
    })
  }, [])
  const [curStep, setCurStep] = useState(0)
  const [gptText, setGptText] = useState([])
  // 从localStorage中获取缓存的模板数据
  const id = GetQueryValue('id')
  let cachedTemplateData

  if (id === '432') {
    cachedTemplateData = localStorage.getItem('xhsTem')
  } else if (id === '731') {
    cachedTemplateData = localStorage.getItem('gzTem')
  } else {
    cachedTemplateData = localStorage.getItem('selectTem')
  }

  // 解析JSON数据
  const initialTemplateData = cachedTemplateData
    ? JSON.parse(cachedTemplateData)
    : null
  // 新增一个状态用于缓存模板数据
  const [templateData, setTemplateData] = useState(initialTemplateData)

  function jumpTo(cur, obj) {
    setCurStep(cur)
  }
  GetQueryValue('id')

  function handleUpdateCurStep(newStep, newTxt) {
    setCurStep(newStep)
    setGptText([newTxt, ...gptText])
  }

  return (
    <div className={styles.writePage}>
      {/* Use conditional rendering */}
      {templateData && (
        <>
          <StepHeaderMod
            curStep={curStep}
            hideStep={true}
            title={templateData.title}
          />
          <div className={styles.content}>
            <div className={styles.content_left}>
              <TemFormMod
                templateData={templateData}
                curStep={curStep}
                jumpTo={(cur, obj) => jumpTo(cur, obj)}
                onUpdateCurStep={handleUpdateCurStep}
              />
            </div>
            <div className={styles.content_right}>
              {curStep === 0 && (
                <EmptyMod
                  icon={<Icon1 />}
                  text={
                    <div>
                      <p>请填写内容或要求</p>
                      <p>AI 为您智能生成{templateData.title}</p>
                    </div>
                  }
                />
              )}
              {curStep !== 0 && (
                <TemRightMod
                  curStep={curStep}
                  gptText={gptText}
                  jumpTo={(cur, obj) => jumpTo(cur, obj)}
                />
              )}
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default GolbalTem
